class LinkUserPhoneNumberReq{
    constructor(){
        this.userId = "";
        this.phone = "";
    }
}
export default LinkUserPhoneNumberReq;